import { Component } from '@angular/core';
import { FormConfig, CustomFormAccessor } from '../form-cva.component';
import { Address } from 'src/shared/api';
import { NgControl, FormBuilder } from '@angular/forms';
import { filterNorthAmericanStates } from 'src/shared/utilities/utility-functions';
import { CustomValidators } from 'src/shared/validators/custom-validators';

const addressFormConfig: FormConfig<Address> = {
	id: [''],
	address1: [''],
	address2: [''],
	city: [''],
	state: ['', [CustomValidators.isValidNorthAmericanState]],
	zipCode: [''],
	country: [''],
	description: [''],
};

@Component({
	selector: 'rpshared-address',
	templateUrl: './address.component.html',
})
export class AddressComponent extends CustomFormAccessor<Address> {
	constructor(public ngControl: NgControl, public fb: FormBuilder) {
		super(ngControl, fb, addressFormConfig);
	}

	filteredStates$ = filterNorthAmericanStates(this.form.get('state'));
}
